import React from 'react';

const LockIcon = () => {
    return (
        <svg
            fill="none"
            height="32"
            style={{minWidth: 33}}
            width="33"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                clipRule="evenodd"
                d="M20.553 11.375V8.687c0-1.125-.4-2.093-1.198-2.906-.798-.812-1.75-1.218-2.855-1.218s-2.057.406-2.855 1.218c-.798.813-1.198 1.781-1.198 2.907v2.687h8.106Zm-4.053 12c.696 0 1.31-.27 1.842-.813.532-.541.798-1.166.798-1.875 0-.708-.266-1.333-.798-1.875C17.81 18.271 17.196 18 16.5 18c-.696 0-1.31.27-1.842.813-.532.541-.798 1.166-.798 1.875 0 .708.266 1.333.798 1.875.532.541 1.146.812 1.842.812Zm7.86-12c.696 0 1.31.26 1.842.781S27 13.292 27 14v13.375c0 .708-.266 1.323-.798 1.844-.532.52-1.146.781-1.842.781H8.64c-.696 0-1.31-.26-1.842-.781S6 28.083 6 27.375V14c0-.708.266-1.323.798-1.844.532-.52 1.146-.781 1.842-.781h1.29V8.687c0-1.833.645-3.406 1.934-4.718C13.154 2.656 14.699 2 16.5 2c1.801 0 3.346.656 4.636 1.969 1.29 1.312 1.934 2.885 1.934 4.719v2.687h1.29Z"
                fill="#CCC"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default LockIcon;
